// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__VOdAv","button":"styles_button__DJ7fJ","selected":"styles_selected__v1y3e"};